<section class="gift-card d-flex flex-column flex-md-row justify-content-between">

    <div class="gift-card-image-container p-3">
        <div class="gift-card-image-content">
            <div class="gift-card-image d-flex justify-content-center align-items-center"
                 [ngStyle]="{'background-image': 'url(' + gift.logoUrl + ')'}">
            </div>
            <div *ngIf="gift.partnerLogoUrl"
                 class="gift-card-logo"
                 [ngStyle]="{'background-image': 'url(' + gift.partnerLogoUrl + ')'}">
            </div>
        </div>
    </div>

    <div class="gift-card-info d-flex flex-column">
        <div class="d-flex justify-content-center my-3 justify-content-md-end align-items-center">
            <h1 class="h3 text-white fw-bold gift-item-info-title text-center text-md-right mb-0">
                {{gift.giftName | truncate:[70, '...'] }}
            </h1>
            <i-feather class="gift-card-icon ms-4 text-white stroke-1 flex-shrink-0"
                       name="gift">
            </i-feather>

        </div>
        <div class="d-flex flex-fill">
            <ng-content></ng-content>
        </div>
    </div>

</section>
